/**
 * Resolves whether the preferred-drug additional-information section should
 * render for a selected query reason.
 *
 * @module shouldShowAdditionalInformationForQueryReason
 */

import { ReasonModel } from "../../../../data-model/reasonModel";

/**
 * Returns whether the preferred-drug additional-information section should
 * render for the currently selected query reason.
 *
 * @param reason - Selected query reason text from the dropdown, if any.
 * @param queryReasons - Organization query reasons loaded from Firestore.
 * @returns `true` when the matched reason has `should_show_user_input`
 *   set to `"optional"` or `"required"`.
 */
export const shouldShowAdditionalInformationForQueryReason = (
  reason: string | null,
  queryReasons: ReasonModel[],
): boolean => {
  if (!reason) {
    return false;
  }

  const userInputRequirement = queryReasons.find(
    (reasonItem) => reasonItem.reason === reason,
  )?.should_show_user_input;

  return (
    userInputRequirement === "optional" || userInputRequirement === "required"
  );
};
